import { effectiveDpi, maxGoodWidthMm, formatLength, QUALITY_LABEL, type AssetInfo, type Design, type BuilderSettings, type Unit } from '@gsb/core';

export function dpiOf(a: AssetInfo | undefined, d: Pick<Design, 'trim' | 'widthMm' | 'heightMm'>, b: BuilderSettings) {
  if (!a || a.status !== 'ready') return null;
  return effectiveDpi(a, d.trim, d.widthMm, d.heightMm, b);
}

export function DpiBadge({ asset, design, builder, unit, long }: { asset?: AssetInfo; design: Pick<Design, 'trim' | 'widthMm' | 'heightMm'>; builder: BuilderSettings; unit: Unit; long?: boolean }) {
  const r = dpiOf(asset, design, builder);
  if (!r) return null;
  const text = r.quality === 'vector' ? 'Vector · sharp at any size' : QUALITY_LABEL[r.quality] + ' · ' + Math.round(r.dpi) + ' DPI';
  const tip = r.quality === 'low' ? 'This artwork may appear pixelated at this print size.'
    : r.quality === 'fair' ? 'Should print fine. 300 DPI is best.'
    : r.quality === 'good' ? 'Sharp at this size.' : 'Vector artwork stays sharp at any size.';
  return (
    <span className={'dpi ' + r.quality} title={tip}>
      <i className="dot" />{text}
      {long && r.quality !== 'good' && r.quality !== 'vector' && asset && (
        <span className="muted" style={{ textTransform: 'none', letterSpacing: 0, fontWeight: 600 }}>
          {' '}· sharp up to {formatLength(maxGoodWidthMm(asset, design.trim, builder.dpiGood), unit)} wide
        </span>
      )}
    </span>
  );
}
